import { TIDUser } from './types/TIDUser';

export interface TIDAuthState {
  /**
   * True or false if the user is authenticated
   * @type {boolean}
   */
  isAuthenticated: boolean;
  /**
   * This property will indicate the developer that the TID Provider is still loading information from the cache
   * By default, this state will be true, this will allow the developers to handle async functionality
   * Note: This property will only be true the first time that the app executes
   * @type {boolean}
   */
  isLoading: boolean;
  /**
   * Information of the user in session
   * @type {TIDUser}
   */
  // eslint-disable-next-line sonarjs/no-redundant-optional -- external TIDUser type may already include undefined; the ? lets callers omit it
  user?: TIDUser;
  /**
   * Property that let the developer know if an error happen during the authentication
   * @type {Error}
   */
  error?: Error;
}

export const initialTIDAuthState: TIDAuthState = {
  isLoading: true,
  isAuthenticated: false,
};
